export function reportGlobalError(error: unknown, info?: any): void {
  try {
    const sentry = (window as any).Sentry;
    if (sentry && typeof sentry.captureException === 'function') {
      sentry.captureException(error, { extra: info });
      return;
    }
  } catch {
    // Ignore errors from the reporter to avoid breaking the app
  }
  if (import.meta.env.DEV) {
    // logging removed
  }
}
